<template>
  <nav v-if="!$route.meta.hideNav" class="navbar navbar-expand-lg bg-body-tertiary" data-n="mmo1v6i">
    <router-link class="ps-3 navbar-brand d-inline-flex align-items-center gap-1" to="/">
      <!-- <img src="/images/logos/logo.png" style="width: 24px; height: 24px;" class="img-fluid" alt="Logo" data-n="w34gsdm"> -->

      <span class="nav-flower" aria-hidden="true"></span>
      <span style="font-weight: bold;" data-n="fj6pgfq">Berlin <span class="red"> Connect-the-Dots </span> Tours </span>
    </router-link>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" data-n="4yca9ez">
      <span class="navbar-toggler-icon" data-n="b5fpep7"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav" data-n="xhm7heq">
      <ul class="navbar-nav mx-auto" data-n="12dvph6">
        <li class="nav-item" data-n="zcrha89">
          <router-link class="nav-link" to="/tours">Tours</router-link>
        </li>
        <li class="nav-item" data-n="488nged">
          <router-link class="nav-link" to="/about">About us</router-link>
        </li>
        <li class="nav-item" data-n="yz1elhq">
          <router-link class="nav-link" to="/is-it-for-you">Is it for you?</router-link>
        </li>
      </ul>
      <ul class="navbar-nav" data-n="qdx44yw">
        <template v-if="!isLoggedIn">
          <li class="nav-item" data-n="ybq9b6b">
            <router-link class="nav-link" to="/login">Login</router-link>
          </li>
          <!-- <li class="nav-item" data-n="ccervqc">
            <router-link class="nav-link" to="/register">Register</router-link>
          </li> -->
        </template>
        <template v-else>
          <li class="nav-item">
            <span class="nav-link">{{ user.name }}</span>
            <a v-if="isAdmin" class="nav-link" href="/admin/login">Admin</a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/logout">Logout</router-link>
          </li>
        </template>
      </ul>
    </div>
  </nav>
  <div v-if="!$route.meta.hideNav" id="flash-alert" class="flash-alert" style="display: none;"></div>
  <div class="flowers-bg" aria-hidden="true">
    <div v-for="n in 10" :key="n" class="flower"></div>
  </div>
  <div class="router-view-wrap bg-light">
    <router-view />
  </div>
  <FooterSection v-if="!$route.meta.hideNav" />

  <div id="all-site-popup-w">
    <div id="all-site-popup">
      <div class="box-flex"></div>
      <div class="card" id="all-site-popup-iner">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span id="all-site-popup-title" class="fw-semibold">{{ popupTitle }}</span>
          <button id="all-site-popup-close" class="btn-close btn-close-white" @click="closePopup"></button>
        </div>
        <div class="card-body" id="all-site-popup-body"></div>
      </div>
      <div class="box-flex"></div>
    </div>
  </div>
</template>

<script>
import { provide, reactive, ref } from 'vue'
import H from "./services/helpers.js"
import { storeToRefs } from 'pinia'
import { useUserStore } from './stores/userStore'
import FooterSection from './components/FooterSection.vue'

export default {
  components: { FooterSection },
  setup() {
    const hh = new H()
    provide('hh', hh)
    const userStore = useUserStore()
    const { user, isLoggedIn, isAdmin } = storeToRefs(userStore)
    const U = reactive({ user: user, isAdmin: isAdmin, isLoggedIn: isLoggedIn })
    provide('U', U)
    const popupTitle = ref('')
    const closePopup = () => { document.getElementById('all-site-popup-w').style.display = 'none'; popupTitle.value = '' }
    const openPopup = (title = '') => { popupTitle.value = title; document.getElementById('all-site-popup-w').style.display = 'block' }
    provide('closePopup', closePopup)
    provide('openPopup', openPopup)

    return { hh, user, isLoggedIn, isAdmin, closePopup, popupTitle }
  },
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.router-view-wrap {
  flex: 1;
  padding-bottom: 120px;
}
</style>
